<template>
  <div class="video-main">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="video-content"
      @click="goDetail(item.uuid, 'type')"
    >
      <van-image
        width="260"
        height="180"
        class="video-img"
        :src="item.thumb_img"
      >
        <template v-slot:loading>
          <van-image
            width="127"
            height="82"
            :src="require('@/assets/default.png')"
          />
        </template>
        <template v-slot:error
          ><van-image
            width="127"
            height="82"
            :src="require('@/assets/default.png')"
        /></template>
      </van-image>
      <van-image
        width="38"
        height="38"
        class="video-play"
        :src="require('@/assets/videoPlay.png')"
      >
      </van-image>
      <span class="title" v-html="item.title"></span>
      <span class="player"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      // this.$router.push({
      //   path: "/video/" + id,
      // });
      const detail = this.$router.resolve({ path: "/video/" + id });
      window.open(detail.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.video-main {
  width: 1200px;
  padding-left: 17px;
}

.video-content {
  position: relative;
  float: left;
  width: 259px;
  height: auto;
  margin-top: 30px;
  margin-right: 40px;
  cursor: pointer;
  transition-duration: 0.5s;

  .title {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 260px;
    height: 55px;
    margin-top: 12px;
    overflow: hidden;
    font-size: 18px;
    font-weight: 500;
    line-height: 30px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    ::v-deep span {
      color: rgb(0 71 255 / 100%);
    }
  }

  .player {
    width: 38px;
    height: 38px;
  }

  .video-img {
    border: 2px solid transparent;
  }
}

.video-content:hover {
  position: relative;
  transform: translateY(-15px);

  .video-img {
    border: 2px solid rgb(0 71 255 / 30%);
  }

  .title {
    color: rgb(0 71 255 / 100%);
  }
}

.video-play {
  position: absolute;
  top: 75px;
  left: 112px;
}
</style>
